import React from 'react';

const images = [
    'https://dev.galenium.com/assets/media/images/sample/product_ct.png',
    'https://dev.galenium.com/assets/media/images/sample/concernt.png',
    //'https://dev.galenium.com/assets/media/images/sample/ingredient.png',
    'https://dev.galenium.com/assets/media/images/sample/allcat.png',
    // Add more image URLs as needed
];

const ImageList = () => {
    return (
        <div className="container mx-auto p-4 lg:w-[980px]">
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-3">
                {images.map((url, index) => (
                    <div key={index} className="flex justify-center items-center">
                        <img src={url} alt="" className="lg:h-[240px] h-full object-cover rounded-lg hover:-translate-y-1 hover:shadow-2xl hover:shadow-[#ffd988]" />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ImageList;
